import { createWebHistory, createRouter } from 'vue-router'

import Login from './views/Login.vue'
import TemplateDefault from './views/template/Template.vue'
import Dashboard from './views/dashboad/dashboard.vue'
import { useStore } from './store';
import TreinadoresLista from "@/views/treinadores/TreinadoresLista.vue";
import TreinadorDetalhes from "@/views/treinadores/TreinadorDetalhes.vue";
import TreinadorForm from "@/views/treinadores/TreinadorForm.vue";
import MensagensLista from "@/views/mensagens/MensagensLista.vue";
import MensagemForm from "@/views/mensagens/MensagemForm.vue";
import FinanceiroLista from "@/views/financeiro/FinanceiroLista.vue";
import FinanceiroDetalhes from "@/views/financeiro/FinanceiroDetalhes.vue";
import ConfiguracaoIA from "@/views/ia/ConfiguracaoIA.vue";
import RedeMarketingHome from "@/views/redeMarketing/RedeMarketingHome.vue";
import ConfiguracaoRede from "@/views/redeMarketing/ConfiguracaoRede.vue";
import MembrosLista from "@/views/redeMarketing/MembrosLista.vue";
import MembroForm from "@/views/redeMarketing/MembroForm.vue";
import GenealogiaView from "@/views/redeMarketing/GenealogiaView.vue";
import RanksView from "@/views/redeMarketing/RanksView.vue";
import DashboardRede from "@/views/redeMarketing/DashboardRede.vue";
import RedeLinearView from "@/views/redeMarketing/RedeLinearView.vue";
import ConfiguracaoRanks from "@/views/redeMarketing/ConfiguracaoRanks.vue";


const routes = [
    {
        path: "/login",
        name: "Login",
        component: Login,
    },
    {
        path: "/",
        name: "Home",
        component: TemplateDefault,
        redirect: "/dashboard",
        meta: { requiresLogin: true },
        children: [
            {
                path: "/dashboard",
                name: "Dashboard",
                component: Dashboard,
            },
            {
                path: "/treinadores",
                name: "Treinadores",
                component: TreinadoresLista,
            },
            {
                path: "/treinadores/novo",
                name: "TreinadorNovo",
                component: TreinadorForm,
            },
            {
                path: "/treinadores/editar/:id",
                name: "TreinadorEditar",
                component: TreinadorForm,
            },
            {
                path: "/treinadores/:id",
                name: "TreinadorDetalhe",
                component: TreinadorDetalhes,
            },
            {
                path: "/mensagens",
                name: "Mensagens",
                component: MensagensLista
            },
            {
                path: "/mensagens-detalhe/:id?",
                name: "MensagemDetalhe",
                component: MensagemForm
            },
            {
                path: "/financeiro",
                name: "FinanceiroLista",
                component: FinanceiroLista
            },
            {
                path: "/financeiro-detalhe/:id",
                name: "FinanceiroDetalhe",
                component: FinanceiroDetalhes
            },
            {
                path: "/configuracao-ia",
                name: "ConfiguracaoIA",
                component: ConfiguracaoIA
            },
            {
                path: "/rede-marketing",
                name: "RedeMarketingHome",
                component: RedeMarketingHome
            },
            {
                path: "/rede-marketing/configuracao",
                name: "RedeMarketingConfiguracao",
                component: ConfiguracaoRede
            },
            {
                path: "/rede-marketing/membros",
                name: "RedeMarketingMembros",
                component: MembrosLista
            },
            {
                path: "/rede-marketing/membros/novo",
                name: "RedeMarketingMembroNovo",
                component: MembroForm
            },
            {
                path: "/rede-marketing/genealogia/:membroId?",
                name: "RedeMarketingGenealogia",
                component: GenealogiaView
            },
            {
                path: "/rede-marketing/ranks",
                name: "RedeMarketingRanks",
                component: RanksView
            },
            {
                path: "/rede-marketing/dashboard",
                name: "RedeMarketingDashboard",
                component: DashboardRede
            },
            {
                path: "/rede-marketing/rede-linear/:membroId?",
                name: "RedeMarketingRedeLinear",
                component: RedeLinearView
            },
            {
                path: "/rede-marketing/configuracao/ranks",
                name: "RedeMarketingConfiguracaoRanks",
                component: ConfiguracaoRanks
            }
        ]
    }
]

const router = createRouter({
    history: createWebHistory(),
    routes,
})

router.beforeEach((to, from, next) => {
    const authStore = useStore();
    console.log(authStore.isAuthenticated)
    //se precisar de login e nao estiver autenticado, manda para tela de login
    if (to.meta.requiresLogin && !authStore.isAuthenticated) {
        next('/login')
    } else if (authStore.isAuthenticated && to.path === '/login') {
        //SE ESTIVER AUTENTICADO E TENTAR ACESSAR LOGIN, DIRECIONA PARA DASHBOARD
        next('/dashboard')
    } else {
        next()
    }
    /*if (to.meta.requiresLogin && !authStore.isAuthenticated) {
        next('/login');
    } else {
        next();
    }*/
});

export default router;